import { render, staticRenderFns } from "./custom-native-smart-banner.vue?vue&type=template&id=2c22917e&scoped=true&"
import script from "./custom-native-smart-banner.vue?vue&type=script&lang=js&"
export * from "./custom-native-smart-banner.vue?vue&type=script&lang=js&"
import style0 from "./custom-native-smart-banner.vue?vue&type=style&index=0&id=2c22917e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22917e",
  null
  
)

export default component.exports